import { Component, OnInit, ViewChild } from '@angular/core';
import {Router} from '@angular/router';
import {DashboardService} from '../service/dashboard.service'
// import { MatTableDataSource, MatPaginator } from '@angular/material';
//import {MatTableDataSource} from '@angular/material/table';
import { MatTableDataSource, MatPaginator, MatDatepickerInputEvent, MAT_DATE_FORMATS, DateAdapter, MatSnackBar } from '@angular/material';
import { FormControl } from '@angular/forms';


import { MatDateFormats, MAT_NATIVE_DATE_FORMATS } from '@angular/material';
import Swal, { SweetAlertResult } from 'sweetalert2';

export const GRI_DATE_FORMATS: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    dateInput: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    } as Intl.DateTimeFormatOptions,
  }
};

@Component({
  selector: 'app-registeredagents',
  templateUrl: './registeredagents.component.html',
  styleUrls: ['./registeredagents.component.scss']
})
export class RegisteredagentsComponent implements OnInit {

  userdata;
  agents:any = [];
  searchdata;
  p:number=1;


  minDate: any;
  maxDate: any;

  startDate :any
  endDate  : any

  length: number;
  pageSize: number= 10;
  pageSizeOptions = [ 10, 20,50,100];

  firstname:any;
  lastname:any;
  phone:any

  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource = new MatTableDataSource();
  displayedColumns = ['no' ,'id', 'firstName', 'phone', 'email','date_added','refresh']

  constructor(private router: Router, private service: DashboardService,private readonly adapter: DateAdapter<Date>,private _snackBar: MatSnackBar) {
    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear - 2, 0, 1);
    this.maxDate = new Date(currentYear + 1, 0, 0);
  }

  date = new FormControl(new Date(new Date().setDate(new Date().getDate() - 90)));

  serializedDate = new FormControl((new Date()).toISOString().substring(0,10))

  ngOnInit() {

    this.userdata=JSON.parse(localStorage.getItem('userdata'))

    var today = new Date(); //get todays date
    this.endDate= today.toISOString().substring(0,10) //convert todays date to format eg.2019-08.02 and set it to end date

    today.setDate(today.getDate() - 90) // subtract 7 days from todays date
    this.startDate = today.toISOString().substring(0,10);

    Swal.showLoading();;
     this.service.getAgents({email:this.userdata.email, module:"agent" ,role :this.userdata.role ,minDate: this.startDate, maxDate : this.endDate})
     .toPromise()
     .then(data=>{
       this.agents = data['responseData'];
       //console.log("agents" + this.agents );

       this.searchdata = this.agents;
       this.dataSource.data = this.agents;

       this.dataSource.paginator = this.paginator;
       Swal.close();
  });
}



find(){
     Swal.showLoading();;
     //email:this.ud.email,minDate:this.topperformstartdate,maxDate:this.topperformenddate,duration:days.toString(), role:this.ud.role}
    this.service.getAgents({email:this.userdata.email,module:"agent" , role :this.userdata.role ,minDate: this.startDate, maxDate : this.endDate}).subscribe(data=>{

      this.agents = data['responseData'];
      //console.log("agents" + this.agents )
      this.searchdata = this.agents;
      this.dataSource.data = this.agents;

      this.dataSource.paginator = this.paginator;
      Swal.close();
    });
}

updateDate1(dateObject) {
  // convert object to string then trim it to yyyy-mm-dd
  const stringified = JSON.stringify(dateObject.value);
  this.startDate = stringified.substring(1, 11);
  // this.applicant.contact[0].dob = dob;

  //console.log(this.startDate )
}


updateDate2(dateObject) {
  // convert object to string then trim it to yyyy-mm-dd
  const stringified = JSON.stringify(dateObject.value);
  this.endDate = stringified.substring(1, 11);
  // this.applicant.contact[0].dob = dob;

  //console.log("end date " + this.endDate )
}

applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

myModal(data:any){
  this.firstname = data.firstName
  this.lastname = data.lastName
  this.phone = data.phone
}


viewregistered(){
  this.router.navigate(['/registeredagents']);
}

registeragents(){
  this.router.navigate(['/agentadmission'])
}

stickerlistings(){
  this.router.navigate(['/stickerlistings']);
}
openReset(agent){
  //console.log('selected',agent)
  let payload={
    agent_code:agent.AGENT_CODE,
    email:agent.AGENT_WORK_EMAIL,
    module: 'agent',
    role: "admin",
  }
  this.service.resetAgentPin(payload).subscribe((response:any)=>{
     if(response.responseCode=='000')
     (Swal as any).fire({
       icon:'info',
       text:'Account Reset Mail Sent Successfully!'
     });
     else
     (Swal as any).fire({
      icon:'error',
      text:'Account Reset failed!'
    });
  })
  }

  //confirm login Password to continue
confirmPassword(agent){
  (Swal as any).fire({
    icon:"question",
    allowOutsideClick:false,
    showCancelButton: true,
    text:"Do you really want to rest agent's pin?",
    reverseButtons: true
  }).then((result:SweetAlertResult)=>{
    if(result.value){
      (Swal as any).fire({
        //title: "Identity Confirmation",
        icon:"warning",
        allowOutsideClick:false,
        showCancelButton: true,
        inputPlaceholder: "Confirm your Password",
        input:"password",
        reverseButtons: true
      })
      .then((result:SweetAlertResult)=>{
           if(result.value){
              Swal.showLoading();
              this.service.getLogin({
                email:this.userdata.email,
                password:result.value,
                role:'admin'
              })
              .toPromise()
              .then((responseData: any)=>{
                Swal.close();
                if(responseData.hasOwnProperty('responseCode') && responseData.responseCode==='000'){
                    this.openReset(agent)
                }
                else{
                  (Swal as any).fire({
                    title: 'Wrong credentials!',
                    text: 'Please check and try again',
                    icon: 'error',
                  });
                  setTimeout(()=>{this.confirmPassword(agent)},2000);
                }

              }).catch(error=>{
                (Swal as any).fire({
                  title: 'Connection Failed!',
                  text: 'Login Failed',
                  icon: 'error',
                });
                setTimeout(()=>{this.confirmPassword(agent)},2000);
              })
           }
           else
           this.alertSnackBar('No Password was entered','User Not Verified');
         });
    }
  })

   }
      //trigger the snackbar
      alertSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
          duration: 2000,
        });
    }
}
